import ViewProfile from './ViewProfile/ViewProfile'
import EditProfile from './EditProfile/EditProfile'
import TradesPersonDetails from './ViewProfile/TradesPersonDetails'

export default { EditProfile, ViewProfile, TradesPersonDetails }
